module.exports = __webpack_public_path__ + "img/couples-082.a3e1f89f.jpg";